/* @flow */
import * as React from "react";
import type { State as Settings } from "../../redux/reducer/settings";
import type { Deal, Stock } from "../../redux/CommonTypes";
import type { Action } from "../../redux/action";

// Есть "точка", которая на самом деле представляет собой интервал
export type Point = {
  epoch: number,
  open: number,
  close: number,
  min: number,
  max: number
};

export type BarPoint = [number, number];

// Есть точка точка. Такие мы получаем из сокетов
export type RealtimePoint = {
  date: number,
  value: number,
  stock?: string
};

// Точка с координатами, готовая к отрисовке
export type RenderablePoint = [number, number, RealtimePoint];

// Данные для отрисовки свечи
export type RenderableCandle = {
  range: [number, number],
  open: RenderablePoint,
  close: RenderablePoint,
  minimum: RenderablePoint,
  maximum: RenderablePoint
};

// Конфиг, обеспечивающий уникальность секции
export type Section = {
  stock: string,
  interval: number, // интервал между точками в секундах
  length: number, // продолжительность в миллисекундах
  offset: number // номер сегмента среди таких же сегментов от 0 времени
};

// Тип секции. Со временем меняется, поэтому мы держим его отдельно
export type SectionType = "past" | "present" | "future" | "weekend";

// Все секции на одном экране делят большинство свойств
export type CommonSectionProps = {
  interval: number,
  length: number,
  quantity: number
};

export type Cursor = {
  ratio: number,
  date: number,
  follow: boolean,
  animate: boolean
};

// Чекпоинты это даты между выходными днями и не
export type Checkpoint = {
  source: [number, number],
  offset: number,
  value: number,
  type: "positive" | "negative"
};

export type State = {
  timeSpan: number,
  animateTimeSpan: boolean,
  cursor: Cursor,
  mouseX: number,
  mouseY: number,
  isHovered: boolean,
  isActive: boolean,
  width: number,
  height: number,
  pinchRatio: number,
  extent: [number, number],
  cache: {
    [string]: Array<Point>
  },
  lastLoadedSections: ?CommonSectionProps,
  isLoading: boolean,
  isEngaged: boolean,
  lastEngagementTime: number,
  interval: number,
  checkpoints: Array<Checkpoint>
};

export type Props = {|
  stock: Stock,
  points: Array<RealtimePoint>,
  deals: Array<Deal>,
  settings: Settings,
  intent: ?string,
  mobile?: boolean,
  stats: null | Object,
  visuals: React.ComponentType<*>,
  dispatch: Action => void
|};

export type Payload = {
  stock: string,
  data: Array<Point>,
  isLoading: boolean,
  interval: number
};

export type Scale = (number => number) & { invert: number => number };

// Легаси?
export type PayloadProps = {
  stock: string,
  realtimeCache: Array<RealtimePoint>,
  width: number,
  height: number,
  timeSpan: number,
  sectionSize: number,
  scaleX: Scale,
  type: "line" | "candlestick" | "bar",
  density: number,
  interval: number,
  checkpoints: Array<Checkpoint>
};

export type VisualProps = {
  lastPoint: RenderablePoint,
  points: Array<RenderablePoint>,
  candles: Array<RenderableCandle>,
  sections: Array<Section>,
  payload: Payload,
  scaleX: Scale,
  scaleY: Scale,
  present: RealtimePoint,
  loading: boolean,
  width: number,
  height: number,
  mouseX: number,
  mouseY: number,
  isHovered: boolean,
  isActive: boolean,
  deals: Array<Deal>,
  settings: Settings,
  intent: "CAST_UP" | "CAST_DOWN" | null,
  stats: Object,
  timeSpan: number,
  onBackToReality: () => void,
  onTimeSpanChange: (
    ({ timeSpan: number, animateTimeSpan: boolean }) => {
      timeSpan: number,
      animateTimeSpan: boolean
    }
  ) => void,
  onIntervalChange: number => void,
  interval: number,
  containerProps: Object,
  stock: Stock,
  tradeMode: "tournament" | "binary",
  isEngaged: boolean
};



// WEBPACK FOOTER //
// ./src/components/Chart/NextGenChartTypes.js